import Vue from "vue";
import Router from "vue-router";

// Containers

import TheContainer from "../containers/TheContainer";

// Views - Pages
import Login from "../views/pages/Login";
import Page404 from "../views/pages/Page404";
import Page500 from "../views/pages/Page500";
import Register from "../views/pages/Register";
import ForgetPassword from "../views/pages/ForgetPassword";
import Profile from "../views/pages/Profile";
import ResetPassword from "../views/pages/ResetPassword";
import SetPassword from "../views/pages/SetPassword";

// import Projects from "../views/Projects/Projects";
// import EditProject from "../views/Projects/EditProject";
// import ProjectStatus from "../views/Projects/ProjectStatus";
import Vendors from "../views/vendors/Vendors";
import EditVendor from "../views/vendors/EditVendor";
// import ParentNames from "../views/ParentNames/ParentNames";
import CategoryOpportunity from "../views/Categories/CategoriesOpportunity";
// import CategoryMaster from "../views/Categories/CategoryMaster";

// Admin
import UserManagement from "../views/UserManagement/UserManagement";
import ClientManagement from "../views/ClientManagement/ClientManagement";
import ClientUsers from "../views/ClientManagement/ClientUsers";
import FileImportStatus from "../views/FileImportStatus/FileImportStatus";

// Dashboard
import SummaryDashboard from "../views/SummaryDashboard/SummaryDashboard";
import SpendDashboard from "../views/SpendDashboard/SpendDashboard";
import SupplySpend from "../views/CategorySpend/SupplySpend";
import ServiceSpend from "../views/CategorySpend/ServiceSpend";
import OpportunityDashboard from "../views/OpportunityDashboard/OpportunityDashboard";
import OpportunityList from "../views/OpportunityList/OpportunityList";
// import AchievementDashboard from "../views/AchievementDashboard/AchievementDashboard";

import OpportunityIdentification from "../views/OpportunityIdentification/OpportunityIdentification";
import OpportunityCategories from "../views/OpportunityCategories/OpportunityCategories";

// // Data upload for spend
import ApproveSpendData from "../views/ApproveSpendData/ApproveSpendData";
import ApproveSpendDataFilter from "../views/ApproveSpendData/ApproveSpendData";

import Overview from "../views/Overview/Overview";

Vue.use(Router);

export default new Router({
    mode: "history", // https://router.vuejs.org/api/#mode
    linkActiveClass: "open active",
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        {
            path: "/",
            redirect: "/login",
            name: "",
            component: TheContainer,
            children: [
                {
                    path: "overview",
                    name: "Overview",
                    component: Overview,
                    beforeEnter: (to, from, next) => {
                        guard(to, from, next);
                    }
                },
                {
                    path: "summary-dashboard",
                    name: "Summary Dashboard",
                    component: SummaryDashboard,
                    beforeEnter: (to, from, next) => {
                        guard(to, from, next);
                    }
                },
                {
                    path: "spend-dashboard",
                    name: "Spend Dashboard",
                    component: SpendDashboard,
                    beforeEnter: (to, from, next) => {
                        guard(to, from, next);
                    }
                },
                {
                    path: "supply-spend",
                    name: "Supply Spend",
                    component: SupplySpend,
                    beforeEnter: (to, from, next) => {
                        guard(to, from, next);
                    }
                },
                {
                    path: "service-spend",
                    name: "Service Spend",
                    component: ServiceSpend,
                    beforeEnter: (to, from, next) => {
                        guard(to, from, next);
                    }
                },
                {
                    path: "opportunity-dashboard",
                    name: "Opportunity Dashboard",
                    component: OpportunityDashboard,
                    beforeEnter: (to, from, next) => {
                        guard(to, from, next);
                    }
                },
                {
                    path: "opportunity-list",
                    name: "Opportunity List",
                    component: OpportunityList,
                    beforeEnter: (to, from, next) => {
                        guard(to, from, next);
                    }
                },
                // {
                //     path: "achievement-dashboard",
                //     name: "Achievement Dashboard",
                //     component: AchievementDashboard,
                //     beforeEnter: (to, from, next) => {
                //         guard(to, from, next);
                //     }
                // },
                {
                    path: "opportunity-identification",
                    name: "Opportunity Identification",
                    component: OpportunityIdentification,
                    beforeEnter: (to, from, next) => {
                        guard(to, from, next);
                    }
                },
                {
                    path: "opportunity-categories",
                    name: "Opportunity Categories",
                    component: OpportunityCategories,
                    beforeEnter: (to, from, next) => {
                        guard(to, from, next);
                    }
                },
                {
                    path: "vendors",
                    name: "Vendors",
                    component: Vendors,
                    beforeEnter: (to, from, next) => {
                        guard(to, from, next);
                    }
                },
                {
                    path: "vendors/new",
                    name: "Add Vendor",
                    component: EditVendor,
                    props: {
                        header: true,
                        content: true
                    },
                    beforeEnter: (to, from, next) => {
                        guard(to, from, next);
                    }
                },
                {
                    path: "vendors/edit/:id",
                    name: "Edit Vendor",
                    component: EditVendor,
                    props: {
                        header: true,
                        content: true
                    },
                    beforeEnter: (to, from, next) => {
                        guard(to, from, next);
                    }
                },
                // {
                //     path: "projects",
                //     name: "Projects",
                //     component: Projects,
                //     beforeEnter: (to, from, next) => {
                //         guard(to, from, next);
                //     }
                // },
                // {
                //     path: "projects/new",
                //     name: "Add Project",
                //     component: EditProject,
                //     props: {
                //         header: true,
                //         content: true
                //     },
                //     beforeEnter: (to, from, next) => {
                //         guard(to, from, next);
                //     }
                // },
                // {
                //     path: "projects/edit/:id",
                //     name: "Edit Project",
                //     component: EditProject,
                //     props: {
                //         header: true,
                //         content: true
                //     },
                //     beforeEnter: (to, from, next) => {
                //         guard(to, from, next);
                //     }
                // },
                // {
                //     path: "projects/view/:id",
                //     name: "View Project",
                //     component: EditProject,
                //     props: {
                //         header: true,
                //         content: true
                //     },
                //     beforeEnter: (to, from, next) => {
                //         guard(to, from, next);
                //     }
                // },
                // {
                //     path: "projects/status",
                //     name: "Project Status",
                //     component: ProjectStatus,
                //     beforeEnter: (to, from, next) => {
                //         guard(to, from, next);
                //     }
                // },

                // {
                //     path: "parent-names",
                //     name: "Parent Names",
                //     component: ParentNames,
                //     props: {
                //         header: true,
                //         content: true
                //     },
                //     beforeEnter: (to, from, next) => {
                //         guard(to, from, next);
                //     }
                // },
                // {
                //     path: "categories-opportunities",
                //     name: "Project Opportunity",
                //     component: CategoryOpportunity,
                //     props: {
                //         header: true,
                //         content: true
                //     },
                //     beforeEnter: (to, from, next) => {
                //         guard(to, from, next);
                //     }
                // },
                // {
                //     path: "categories-master",
                //     name: "Category Master",
                //     component: CategoryMaster,
                //     props: {
                //         header: true,
                //         content: true
                //     },
                //     beforeEnter: (to, from, next) => {
                //         guard(to, from, next);
                //     }
                // },
                {
                    path: "client-management",
                    name: "Client Management",
                    component: ClientManagement,
                    props: {
                        header: true,
                        content: true
                    },
                    beforeEnter: (to, from, next) => {
                        guard(to, from, next);
                    }
                },
                {
                    path: "client-users",
                    name: "ClientUsers",
                    component: ClientUsers,
                    props: {
                        header: true,
                        content: true
                    },
                    beforeEnter: (to, from, next) => {
                        guard(to, from, next);
                    }
                },
                {
                    path: "user-management",
                    name: "User Management",
                    component: UserManagement,
                    props: {
                        header: true,
                        content: true
                    },
                    beforeEnter: (to, from, next) => {
                        guard(to, from, next);
                    }
                },
                {
                    path: "file-import-status",
                    name: "File Import Status",
                    component: FileImportStatus,
                    props: {
                        header: true,
                        content: true
                    },
                    beforeEnter: (to, from, next) => {
                        guard(to, from, next);
                    }
                },
                {
                    path: "approve-spend",
                    name: "Spend Data Upload",
                    component: ApproveSpendData,
                    props: {
                        header: true,
                        content: true
                    },
                    beforeEnter: (to, from, next) => {
                        guard(to, from, next);
                    }
                },
                {
                    path: "approve-spend/vendor-name=:vendor_name",
                    name: "Spend Data Invoice for vendor",
                    component: ApproveSpendDataFilter,
                    props: {
                        header: true,
                        content: true
                    },
                    beforeEnter: (to, from, next) => {
                        guard(to, from, next);
                    }
                },
                {
                    path: "approve-spend/month=:month",
                    name: "Spend Data Invoice for month",
                    component: ApproveSpendDataFilter,
                    props: {
                        header: true,
                        content: true
                    },
                    beforeEnter: (to, from, next) => {
                        guard(to, from, next);
                    }
                },
                {
                    path: "approve-spend/quarter=:quarter",
                    name: "Spend Data Invoice for quarter",
                    component: ApproveSpendDataFilter,
                    props: {
                        header: true,
                        content: true
                    },
                    beforeEnter: (to, from, next) => {
                        guard(to, from, next);
                    }
                },
                {
                    path: "approve-spend/year=:year",
                    name: "Spend Data Invoice for year",
                    component: ApproveSpendDataFilter,
                    props: {
                        header: true,
                        content: true
                    },
                    beforeEnter: (to, from, next) => {
                        guard(to, from, next);
                    }
                },
                {
                    path: "profile",
                    name: "User Profile",
                    component: Profile,
                    props: {
                        header: true,
                        content: true
                    },
                    beforeEnter: (to, from, next) => {
                        guard(to, from, next);
                    }
                },
                {
                    path: "reset-password",
                    name: "Reset Password",
                    component: ResetPassword,
                    props: {
                        header: true,
                        content: true
                    },
                    beforeEnter: (to, from, next) => {
                        guard(to, from, next);
                    }
                }
            ]
        },
        {
            path: "/",
            redirect: "/404",
            name: "",
            component: {
                render(c) {
                    return c("router-view");
                }
            },
            children: [
                {
                    path: "404",
                    name: "Page404",
                    component: Page404
                },
                {
                    path: "500",
                    name: "Page500",
                    component: Page500
                },
                {
                    path: "login",
                    name: "Login",
                    component: Login
                },
                {
                    path: "register",
                    name: "Register",
                    component: Register
                },
                {
                    path: "forget-password",
                    name: "Forget Password",
                    component: ForgetPassword
                },
                {
                    path: "set-password/:id",
                    name: "setPassword",
                    component: SetPassword
                },
                {
                    path: "forgot-password/:id",
                    name: "forgotPassword",
                    component: SetPassword
                }
            ]
        },
        {
            path: "*",
            name: "404",
            component: Page404
        }
    ]
});

// Guard function to check if token exist before each route enters
const guard = (to, from, next) => {
    if (sessionStorage.getItem("vue-session-key")) {
        const session = JSON.parse(sessionStorage.getItem("vue-session-key"));
        const accessToken = session.accessToken;
        if (!accessToken) {
            window.location.href = "/login";
        } else {
            next();
        }
    } else {
        window.location.href = "/login";
    }
};
